
import { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom"
import { ExpertRatingPage } from "./html-pages";
import { AuthService } from "../services/auth-service"
import { SessionService } from "../services/session-service";
import { RaterModel } from "../models/rater"
import { SessionModel } from "../models/session";
import { SessionDeviceModel } from "../models/session-device";
import { SpeakerModel } from "../models/speaker";

const DEFAULT_COLORS = [
  "#2563eb",
  "#16a34a",
  "#f97316",
  "#9333ea",
  "#dc2626",
  "#0891b2",
];
const likertOptions = [1, 2, 3, 4, 5];
const evaluation_one = [
  ["Interpretability", "This dashboard makes the collaboration patterns easy for me to understand."],
  ["Usefulness for feedback", "This Feedbacks provided useful information and helped me reflect on my collaboration to identify ways to improve."],
  ["Clarity", "The information presented in the dashboard is clear and easy to follow."],
  ["Actionability", "Interacting with this dashboard help me to determine actionable next steps."],
  ["Confidence in interpretation", "I can confidently rely on the  information provided in this dashboard to judge my collaboration pattern."]
]

const evaluation_two = [
  ["Data modality", "The integration of different modalities of metric  impact the richness of interpretation/synthesis."],
  ["Complementarity of Signals", "The feedback draws on classes of metrics that reinforce or support the same interpretation."],
  ["Contextual Interpretation", "The feedback is contextualized by interpreting a collaboration indicator in relation to one or more other collaboration indicators, rather than in isolation."],
  ["Relational Reasoning", "The feedback reflects how one collaboration indicator/behavior may influence or be associated with another."],
  ["Coverage ", "The feedback captures a broad range of behaviors rather than focusing narrowly on one aspect of collaboration."]
]

const evaluation_three = [
  ["Claims Accuracy", "The feedback includes claims that are not clearly supported by the data."],
  ["Evidence Traceability", "The feedback clearly links its conclusions to specific elements of the data."],
  ["Consistency", "The feedback is internally consistent and does not contain contradictions."],
  ["Sepcifity", "The feedback provides specific, data-grounded insights rather than vague statements."],
  ["Trustworthiness", "I would trust this feedback as a reliable interpretation of the data."]
]

const evaluation_one_instruction = [
  "Interact with each dashboard as needed (click, navigate, expand) to understand the feedback.",
  "Focus on how interaction helps you explore or understand the feedback"
]

const evaluation_two_instruction = [
  "Interact with each dashboard as needed (click, navigate, expand) to understand the feedback.",
  "Focus on how either single or multi data sources impact better understanding of the feedback "
]

const evaluation_three_instruction = [
  "Interact with each dashboard as needed (click, navigate, expand) to understand the feedback.",
  "Focus on the consistency, accuracy and level of halucination observed during your interaction"
]
function ExpertRatingComponent() {

  const [nextPage, setNextPage] = useState("reportoptionpage")
  const [selectedItemForRating, setSelectedItemForRating] = useState(-1)
  const [itemsForRating, setItemsForRating] = useState([])

  const pageTitle = useRef("Expert Rating")
  const session = useRef(null)
  const [currentForm, setCurrentForm] = useState("")
  const [evaluatorType, setEvaluatorType] = useState("")
  const [aliasExpertId, setAliasExpertId] = useState("")
  const [evaluationOption, setEvaluationOption] = useState([])
  const [evaluationOptionInstruction, setEvaluationOptionInstruction] = useState([])
  const [showAlert, setShowAlert] = useState(false)
  const [alertMessage, setAlertMessage] = useState("")
  const [alertHeading, setAlertHeading] = useState("")
  const [notes, setNotes] = useState("");
  const [ratings, setRatings] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [sessionId, setSessionId] = useState(-1)
  const [sessionDeviceId, setSessionDeviceId] = useState(-1)
  const [sessionDevice, setSessionDevice] = useState(null)
  const [timeRange, setTimeRange] = useState([0, 1])

  const [transcripts, setTranscripts] = useState(null)
  const [videoMetrics, setVideoMetrics] = useState(null)
  const [session1Transcripts, setSession1Transcripts] = useState([]);
  const [session1VideoMetrics, setSession1VideoMetrics] = useState([])
  const [transcriptDoneLoading, setTranscriptDoneLoading] = useState(false);
  const [videoMetricDoneLoading, setVideoMetricDoneLoading] = useState(false);
  const [reflectionDashboardDoneLoading, setReflectionDashboardDoneLoading] = useState(false);
  const [dashboardPage, setDashboardPage] = useState("")
  const [startTime, setStartTime] = useState()
  const [endTime, setEndTime] = useState()
  const details = useRef("Individual")
  const [currentTranscript, setCurrentTranscript] = useState(null)
  const [showFeatures, setShowFeatures] = useState([])
  const [showBoxes, setShowBoxes] = useState([])

  const synthesizedFeedbackMetrics = useRef(null);
  const llmSessionAnalysis = useRef(null)
  const promptHistory = useRef({})
  const promptResponses = useRef({})
  const synthesizedData = useRef({})
  const [selectedMomentIdAndIndex, setSelectedMomentIdAndIndex] = useState(null);
  const [sessionNameForReflecDashboard, setSessionNameForReflecDashboard] = useState("")
  const [groupNameForReflecDashboard, setGroupNameForReflecDashboard] = useState("")
  const [isThinking, setIsThinking] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [speakers, setSpeakers] = useState([]);
  const studentAllRatingsCompleted = useRef({quantDash:false, refDash:false})
  const navigate = useNavigate()
  const sessionService = new SessionService()
  const authService = new AuthService()



  useEffect(() => {
    let featuresArr = [
      "Emotional tone",
      "Analytic thinking",
      "Clout",
      "Authenticity",
      "Confusion",
      "Participation",
      "Social Impact",
      "Responsivity",
      "Internal Cohesion",
      "Newness",
      "Communication Density",
      "Attention Level",
      "Facial Emotions",
      "Object Focused On"
    ]
    initChecklistData(featuresArr, setShowFeatures)
    // initialize the components toolbar
    let boxArr = [
      "Timeline control",
      "Discussion timeline",
      "Keyword detection",
      "Discussion features",
      "Radar chart",
      "Participation",
      "Social Impact",
      "Responsivity",
      "Internal Cohesion",
      "Newness",
      "Communication Density",
      "Video Metrics"
    ]
    initChecklistData(boxArr, setShowBoxes)
  }, []);

  // first useEffect to be called one the evalutor class is selected
  useEffect(() => {
    if (evaluatorType === "student" && aliasExpertId !== "") {
      // setItemsForRating([{ rating_item_id: -1, sessId: 158, sessDevId: 443, speaker: "jciohvud", raterId: aliasExpertId, dashboardType: "quantitative", evalCat: "visualization" },
      // { rating_item_id: -1, sessId: 158, sessDevId: 443, speaker: "jciohvud", raterId: aliasExpertId, dashboardType: "reflection", evalCat: "reflection" }])
      verifyExpertId(aliasExpertId)

    } else if (evaluatorType === "expert" && aliasExpertId !== "") {
      verifyExpertId(aliasExpertId)

    }
  }, [evaluatorType, aliasExpertId])

  useEffect(() => {
    if (itemsForRating.length > 0) {
      loadDashboard(itemsForRating[0])
    }

  }, [itemsForRating])


  useEffect(() => {
    if (selectedItemForRating !== -1 && sessionId !== -1 && sessionDeviceId !== -1) {
      if (selectedItemForRating.dashboardType === "quantitative") {
        fetchTranscript(sessionId, sessionDeviceId, selectedItemForRating.speaker, setTranscripts)
        fetchVideoMetric(sessionId, sessionDeviceId, selectedItemForRating.speaker, setVideoMetrics)
        setRatings(Object.fromEntries(evaluationOption.map((item) => [item[0], 0])))
        setNextPage("dashboardratingpage")
      } else if (selectedItemForRating.dashboardType === "reflection") {
        loadReflectiondashboard(sessionId, sessionDeviceId, selectedItemForRating.speaker)
        setDashboardPage(selectedItemForRating.dashboardType)
        setRatings(Object.fromEntries(evaluationOption.map((item) => [item[0], 0])))
        setNextPage("dashboardratingpage")
      }
    }
  }, [selectedItemForRating, sessionId, sessionDeviceId])

  useEffect(() => {
    if (transcripts !== null && videoMetrics !== null) {
      const sessionLen = Object.keys(session.current).length > 0 ? session.current.length : 0
      const sTime = Math.round(sessionLen * timeRange[0] * 100) / 100
      const eTime = Math.round(sessionLen * timeRange[1] * 100) / 100
      setStartTime(sTime)
      setEndTime(eTime)

      generateDisplayTranscripts(transcripts, sTime, eTime)
      generateDisplayVideoMetrics(videoMetrics, sTime, eTime)
    }

  }, [transcripts, videoMetrics]);

  useEffect(() => {
    if (transcriptDoneLoading && videoMetricDoneLoading) {
      setDashboardPage(selectedItemForRating.dashboardType)
    }
  }, [transcriptDoneLoading, videoMetricDoneLoading])

  const completedCount = useMemo(
    () => Object.values(ratings).filter((value) => value > 0).length,
    [ratings]
  );


  // ___________________________________________________________ 
  //  STEP1: Clicking the  continue buttion   call this function to verify the selections and input              
  // --------------------------------------------------------

  const getUserParameters = (evaluatorType, alias_expertid) => {
    if (evaluatorType === '') {
      setAlertHeading("Error")
      setAlertMessage("Please Select Your Role");
      setShowAlert(true);
      document.getElementById("evaluaortype").focus();
    } else if (alias_expertid === '') {
      setAlertHeading("Error")
      setAlertMessage("Please Enter Your Expert ID");
      setShowAlert(true);
      document.getElementById("expertid").focus();
    } else {
      setAliasExpertId(alias_expertid)
    }
  }

  // ___________________________________________________________ 
  //   STEP2: This is called to authenticate the username, fetch user data and call load session           
  // --------------------------------------------------------

  const verifyExpertId = async (expertid) => {
    const fetchData =  new SessionService().getRaterDetailByExpertId(expertid)
    fetchData
      .then(
        (response) => {
          if (response.status === 200) {
            response.json().then((jsonArrayObj) => {
              const expert_data = RaterModel.fromJsonList(jsonArrayObj)
              const items = expert_data.map((detail, index) => { return { rating_item_id: detail.id, sessId: detail.sessionid, sessDevId: detail.sessiondeviceid, speaker: detail.speakertag, raterId: detail.raterid, dashboardType: detail.dashboardtype, evalCat: detail.evaluationCategory } })
              setItemsForRating(items)
            })
          } else {
            setAlertHeading("Error")
            setAlertMessage("Invalid Expert ID");
            setShowAlert(true);
          }
        },
        (apierror) => {
          console.log(
            "Expert Rating: verifyExpertId 1 ",
            apierror,
          )
        },
      )
  }

  const loadDashboard = (selecteditem) => {
    setSession1Transcripts([])
    setTranscripts(null)
    setVideoMetrics(null)
    setTranscriptDoneLoading(false)
    setVideoMetricDoneLoading(false)

    loadSession(selecteditem.sessId)
    loadSessionDevice(selecteditem.sessDevId)
    getSpeakers(selecteditem.sessId, selecteditem.sessDevId)
    const evalopt = selecteditem.evalCat == "visualization" || selecteditem.evalCat == "reflection" ? evaluation_one : selecteditem.evalCat == "multimodal" || selecteditem.evalCat == "unimodal" ? evaluation_two : evaluation_three
    const evaloptInt = evalopt == evaluation_one ? evaluation_one_instruction : evalopt == evaluation_two ? evaluation_two_instruction : evaluation_three_instruction
    setEvaluationOption(evalopt)
    setEvaluationOptionInstruction(evaloptInt)
    setSelectedItemForRating(selecteditem)
  }

  const loadSession = (sessionid) => {
    const fetchData = sessionService.getSessionById(sessionid)
    fetchData
      .then(
        (response) => {
          if (response.status === 200) {
            response.json().then((jsonArrayObj) => {
              const session_data = SessionModel.fromJson(jsonArrayObj)

              session.current = session_data
              pageTitle.current = session_data.name
              setSessionId(session_data.id);
              // setReload(reload + 1)
            })
          } else {
            setAlertHeading("Error")
            setAlertMessage("No Previous Sessions Found for this User");
            setShowAlert(true);
          }
        },
        (apierror) => {
          console.log(
            "Student dashboard func: loadSession 1 ",
            apierror,
          )
        },
      )
  }

  const loadSessionDevice = (session_device_id) => {
    const fetchData = sessionService.getSessionDeviceForClient(session_device_id)
    fetchData
      .then(
        (response) => {
          if (response.status === 200) {
            response.json().then((jsonObj) => {
              const session_device = SessionDeviceModel.fromJson(jsonObj)
              setSessionDevice(session_device)
              setSessionDeviceId(session_device.id);
            })
          } else {
            setAlertHeading("Error")
            setAlertMessage("No Previous Sessions device Found for this User");
            setShowAlert(true);
          }
        },
        (apierror) => {
          console.log(
            "Student dashboard func: loadSession 1 ",
            apierror,
          )
        },
      )
  }

  const getSpeakers = (sessionid,sessiondeviceid) => {
      const fetchData = sessionService.getSessionDeviceSpeakers(sessionid,sessiondeviceid);
      fetchData.then(
        (response) => {
          if (response.status === 200)
            response.json().then((jsonObj) => {
              const input = SpeakerModel.fromJsonList(jsonObj)
              if (input && input.length) {
                setSpeakers(input);
              }
            });
        },
        (apierror) => {
          console.log("podcomponent func getspeakers 1", apierror);
        }
      );
    };

  const fetchTranscript = async (sessionId, deviceId, username, setMetric) => {
    try {
      let response = null
      response = await sessionService.getSessionDeviceTranscriptsByAlias(sessionId, deviceId, username)

      if (response !== null && response.status === 200) {
        const jsonObj = await response.json()
        const fetched_trancript_metrics = jsonObj.map((trancript_metrics) => {
          return { ...trancript_metrics['transcript'], speaker_metrics: trancript_metrics['speaker_metrics'] }
        })

        setMetric(fetched_trancript_metrics)
      } else if (response !== null && (response.status === 400 || response.status === 401)) {
        console.log(response, "no transcript obj")
      }
    } catch (error) {
      console.log(
        "byod-join-component error func : fetch transcript",
        error,
      )
    }
  }

  const fetchVideoMetric = async (sessionId, deviceId, username, setMetric) => {
    try {
      let response = null
      response = await sessionService.getSessionDeviceVideoMetricsByAlias(sessionId, deviceId, username)

      if (response !== null && response.status === 200) {
        const fetched_video_metrics = await response.json()

        setMetric(fetched_video_metrics)
      } else if (response.status === 400 || response.status === 401) {
        console.log(response, "no videometrics obj")
      }
    } catch (error) {
      console.log(
        "byod-join-component error func : fetch video metrics",
        error,
      )
    }
  }

  const generateDisplayTranscripts = (transcripts, s, e) => {
    setSession1Transcripts(
      transcripts.filter((t) => t.start_time >= s && t.start_time <= e),
    )
    setTranscriptDoneLoading(true);
  }

  const generateDisplayVideoMetrics = (videoMetrics, s, e) => {
    setSession1VideoMetrics(
      videoMetrics.filter((v) => v.time_stamp >= s && v.time_stamp <= e),
    )
    setVideoMetricDoneLoading(true);
  }

  ///------------------------------------------------------------------------//
  //Dashboard option two implementation
  //-----------------------------------------------------------------------//

  const loadReflectiondashboard = async (sessionid, deviceid, username) => {
    setReflectionDashboardDoneLoading(false)
    let actionstatus = await extractParticipantData(sessionid, deviceid, username)
    if (actionstatus) {
      setSessionNameForReflecDashboard(session.current?.name)
      setGroupNameForReflecDashboard(sessionDevice?.name)
      setReflectionDashboardDoneLoading(true)
    }

  };


  const extractParticipantData = async (sessionid, deviceId, username) => {
    const resp = await loadSynthesizedMetric(sessionid, deviceId)

    let respObj = buildData("Participant level sesssion analysis", sessionid, deviceId, username, null, null)
    if (Object.keys(respObj).length === 0 || resp === false) {
      return false;
    }

    const ret = await loadLLMAnalytics(respObj)

    if (ret) {
      synthesizedData.current = respObj
      await loadprompthistory(sessionid, deviceId, username)
      setSelectedMomentIdAndIndex([0, synthesizedData.current.participant_level_metric[0].windowid])
    }

    return ret

  }

  const interactivePromptFnc = async (selSessionId, selSessionDeviceId, default_question_id, question) => {
    let respObj = buildData("interactive prompting", selSessionId, selSessionDeviceId, selectedItemForRating.speaker, default_question_id, question)
    let existingPrompt = null
    if (promptHistory.current.hasOwnProperty(selSessionId) && promptHistory.current[selSessionId].hasOwnProperty(selSessionDeviceId)) {
      existingPrompt = promptHistory.current[selSessionId][selSessionDeviceId].find(p => (default_question_id !== -1 && p?.default_question_id === default_question_id)) ?? null;
    }

    if (existingPrompt !== null) {
      if (promptResponses.current.hasOwnProperty(selSessionId) && promptResponses.current[selSessionId].hasOwnProperty(selSessionDeviceId)) {
        promptResponses.current[selSessionId][selSessionDeviceId].push([question, existingPrompt.answer])
      } else if (promptResponses.current.hasOwnProperty(selSessionId)) {
        promptResponses.current[selSessionId][selSessionDeviceId] = [[question, existingPrompt.answer]]
      } else {
        promptResponses.current[selSessionId] = {
          [selSessionDeviceId]: [[question, existingPrompt.answer]]
        }
      }

    } else {
      try {

        const response = await new SessionService().getLLMPromptResponse(respObj);

        if (response.status === 200) {
          const jsonObj = await response.json()

          if (promptResponses.current.hasOwnProperty(selSessionId) && promptResponses.current[selSessionId].hasOwnProperty(selSessionDeviceId)) {
            promptResponses.current[selSessionId][selSessionDeviceId].push([question, jsonObj.answer])
          } else if (promptResponses.current.hasOwnProperty(selSessionId)) {
            promptResponses.current[selSessionId][selSessionDeviceId] = [[question, jsonObj.answer]]
          } else {
            promptResponses.current[selSessionId] = {
              [selSessionDeviceId]: [[question, jsonObj.answer]]
            }
          }

          // console.log(jsonObj.answer)
        } else if (response.status === 400) {
          console.log("LLM api response", response.message)
        }
      } catch (error) {
        console.log(
          "podcomponent interactivePromptFnc",
          error,
        )
      }
    }
  }

  const buildData = (reporttype, sessionId, deviceId, username, defaultQuestionId, question) => {
    let retObj = {}
    if (synthesizedFeedbackMetrics.current) {
      if (reporttype === "Participant level sesssion analysis") {
        retObj["participant_name"] = username
        retObj["sessionid"] = sessionId
        retObj["sessiondeviceid"] = deviceId
        retObj["retrieve_existing_report"] = "true"
        retObj["source"] = "student"
        retObj["promptcontext"] = ""
        retObj["promptrefinement"] = ""
        retObj["participant_level_metric"] = synthesizedFeedbackMetrics.current["participants_level"][username]
        retObj["session_level_metric"] = synthesizedFeedbackMetrics.current["session_all_metrics"][username]
        retObj["group_level_metric"] = synthesizedFeedbackMetrics.current["group_level"]
      } else if (reporttype === "interactive prompting") {
        retObj["participant_name"] = username
        retObj["sessionid"] = sessionId
        retObj["sessiondeviceid"] = deviceId
        retObj["retrieve_existing_answer"] = "true"
        retObj["default_question_id"] = defaultQuestionId
        retObj["question"] = question
        retObj["window_level_metric"] = synthesizedFeedbackMetrics.current["window_level"]
        retObj["session_level_metric"] = synthesizedFeedbackMetrics.current["session_all_metrics"]
        retObj["group_level_metric"] = synthesizedFeedbackMetrics.current["group_level"]
      }
    }
    return retObj
  }

  const loadSynthesizedMetric = async (sessionid, deviceId) => {
    const data = await getSynthesizedMetric(sessionid, deviceId)
    if (data === null) {
      return false
    }

    synthesizedFeedbackMetrics.current = data

    return true
  }

  const loadLLMAnalytics = async (respObj) => {

    const analysis = await getLLMAnalytics(respObj)
    if (analysis === null) {
      return false
    }

    llmSessionAnalysis.current = analysis

    return true
  }


  const loadprompthistory = async (sessionid, deviceid, username) => {
    if (!promptHistory.current.hasOwnProperty(sessionid)) {
      const prompt = await getPrompthistory(sessionid, deviceid, username)

      if (prompt === null) {
        return false
      }

      promptHistory.current[sessionid] = {
        [deviceid]: prompt
      }
    } else {
      if (!promptHistory.current[sessionid].hasOwnProperty(deviceid)) {

        const prompt = await getPrompthistory(sessionid, deviceid, username)
        if (prompt === null) {
          return false
        }

        promptHistory.current[sessionid][deviceid] = prompt

      }

    }
    return true
  }


  const getSynthesizedMetric = async (sessionid, deviceId) => {
    try {
      const response = await new SessionService().getSynthesizedFeedbackMetrics(sessionid, deviceId);
      if (response.status === 200) {
        const jsonObj = response.json()
        return jsonObj;
      } else {
        return null
      }
    } catch (error) {
      console.log(
        "Expert rating getSynthesizedMetric",
        error,
      )
      return null
    }
  }

  const getLLMAnalytics = async (respObj) => {
    try {
      const response = await new SessionService().getLLMFeedbackBasedOnMetrics(respObj);

      if (response.status === 200) {
        const jsonObj = await response.json()
        return jsonObj.answer
      } else if (response.status === 400) {
        console.log("LLM api response", response.message)
        return null
      }
    } catch (error) {
      console.log(
        "Expert ratingloadReflectiondashboard",
        error,
      )
      return null
    }
  }

  const getPrompthistory = async (sessionid, deviceId, username) => {
    try {
      const response = await new SessionService().get_llm_question_answer_interactions(sessionid, deviceId, username);

      if (response.status === 200) {
        const jsonObj = await response.json()
        return jsonObj
      } else if (response.status === 400) {
        return null
      }
    } catch (error) {
      console.log(
        "Expert rating loadprompthistory",
        error,
      )
      return null
    }
  }


  ///------------------------------------------------------------------------//
  // END OF IMPLEMENTATION FOR THE REFLECTION DASHBOARD 
  //-----------------------------------------------------------------------//

  const handleRate = (criterion, value) => {
    setRatings((prev) => ({ ...prev, [criterion]: value }));
    setSubmitted(false);
  };

  const ResetTimeRange = (values) => {
    if (session.current !== null) {
      const sessionLen =
        Object.keys(session.current).length > 0 ? session.current.length : 0
      setTimeRange(values)
      const start = Math.round(sessionLen * values[0] * 100) / 100
      const end = Math.round(sessionLen * values[1] * 100) / 100
      setStartTime(start)
      setEndTime(end)
      generateDisplayTranscripts(session1Transcripts, start, end)
      generateDisplayVideoMetrics(session1VideoMetrics, start, end)
    }
  }

  const handlePrev = () => {
    if (currentIndex <= 0) return;
    handleNavigationChange(currentIndex - 1, itemsForRating[currentIndex - 1]);
  };

  const handleNext = () => {
    if (currentIndex >= itemsForRating.length - 1 || itemsForRating.length === 0) return;
    handleNavigationChange(currentIndex + 1, itemsForRating[currentIndex + 1]);
  };

  const handleNavigationChange = (index, itemsForRating) => {
    setCurrentIndex(index);
    setRatings(Object.fromEntries(evaluationOption.map((item) => [item[0], 0])))
    setNotes("")
    setSubmitted(false);
    loadDashboard(itemsForRating)
  };


  const handleSubmit = async (allComplete) => {
    // e.preventDefault();
    if (!allComplete) return;

    ratings.notes = notes
    const payload = {
      id: selectedItemForRating.rating_item_id,
      sessionid: selectedItemForRating.sessId,
      sessionDeviceId: selectedItemForRating.sessDevId,
      speakerTag: selectedItemForRating.speaker,
      raterid: selectedItemForRating.raterId,
      evaluationCategory: selectedItemForRating.evalCat,
      response: ratings,
    };

    // console.log("payload ",payload)
    try {
      const response = await new SessionService().postRating(payload);

      if (response.status === 200) {
        // console.log("Submitted rating form:", payload);
       
        if (selectedItemForRating.dashboardType === "quantitative"){
          studentAllRatingsCompleted.current.quantDash = true 
        } 
        if (selectedItemForRating.dashboardType === "reflection"){
          studentAllRatingsCompleted.current.refDash = true 
        }

        if (studentAllRatingsCompleted.current.quantDash && studentAllRatingsCompleted.current.refDash){
          setAlertHeading("Success")
          setAlertMessage("All rating submission completed! Thank you for taking time to complete these rating");
          setShowAlert(true);
        }else{
          setSubmitted(true);
          setAlertHeading("Success")
          setAlertMessage("Rating Submission Successful!");
          setShowAlert(true);
        }
        
      } else if (response.status === 400) {
        setAlertHeading("Error")
        setAlertMessage("Rating Submission Unsuccessful, Please contact Admin");
        setShowAlert(true);
      }
    } catch (error) {
      console.log(
        "Expert rating loadprompthistory",
        error,
      )
      return null
    }

  };

  const seeAllTranscripts = () => {
    if (Object.keys(currentTranscript) > 0 && sessionDevice !== null) {
      setCurrentForm("gottoselectedtranscript")
    } else if (sessionDevice !== null) {
      setCurrentForm("gototranscript")
    }
  }

  const closeDialog = () => {
    setCurrentForm("")
  }
  const navigateToLogin = (confirmed = false) => {
     if (!studentAllRatingsCompleted.current.quantDash || !studentAllRatingsCompleted.current.refDash){
      setAlertHeading("Error")
      setAlertMessage("You have not completed rating for all the dashboards!");
      setShowAlert(true);
      return
     }
    return navigate("/")
  }

  // const loading = () => {
  //   return session.current === null || transcripts.length === 0
  // }

  const initChecklistData = (featuresArr, setFn) => {
    let valueInd = 0
    let showFeats = []
    for (const feature of featuresArr) {
      showFeats.push({ label: feature, value: valueInd, clicked: true })
      valueInd++
    }
    setFn(showFeats)
  }

  const closeAlert = () => {
    setShowAlert(false)
    if (studentAllRatingsCompleted.current.quantDash && studentAllRatingsCompleted.current.refDash){
          navigateToLogin()
    }
  }

  const onClickedTimeline = (transcript) => {
    setCurrentForm("Transcript")
    setCurrentTranscript(transcript)
  }

  const onClickedKeyword = (transcript) => {
    setCurrentTranscript(transcript)
    setCurrentForm("gottoselectedtranscript")
  }

  return (
    <ExpertRatingPage
      currentForm={currentForm}
      closeDialog={closeDialog}
      nextPage={nextPage}
      pageTitle={pageTitle.current}
      navigateToLogin={navigateToLogin}
      setShowAlert={setShowAlert}
      showAlert={showAlert}
      closeAlert={closeAlert}
      alertMessage={alertMessage}
      alertHeading = {alertHeading}
      getUserParameters={getUserParameters}
      // loading={loading}
      itemsForRating={itemsForRating}
      evaluatorType={evaluatorType}
      setEvaluatorType={setEvaluatorType}
      loadDashboard={loadDashboard}
      dashboardPage={dashboardPage}
      session1Transcripts={session1Transcripts}
      session1VideoMetrics={session1VideoMetrics}
      transcriptDoneLoading={transcriptDoneLoading}
      videoMetricDoneLoading={videoMetricDoneLoading}
      startTime={startTime}
      endTime={endTime}
      details={details.current}
      session={session.current}
      sessionDevice={sessionDevice}
      setRange={ResetTimeRange}
      onClickedTimeline={onClickedTimeline}
      onClickedKeyword={onClickedKeyword}
      showFeatures={showFeatures}
      showBoxes={showBoxes}
      seeAllTranscripts={seeAllTranscripts}
      currentTranscript={currentTranscript}
      setCurrentForm={setCurrentForm}
      reflectionDashboardDoneLoading={reflectionDashboardDoneLoading}

      llmSessionAnalysis={llmSessionAnalysis.current}
      synthesizedData={synthesizedData.current}
      promptResponses={promptResponses.current}
      setSelectedMomentIdAndIndex={setSelectedMomentIdAndIndex}
      selectedMomentIdAndIndex={selectedMomentIdAndIndex}
      sessionNameForReflecDashboard={sessionNameForReflecDashboard}
      groupNameForReflecDashboard={groupNameForReflecDashboard}
      interactivePromptFnc={interactivePromptFnc}
      isThinking={isThinking}
      setIsThinking={setIsThinking}
      sessionId={sessionId}
      sessionDeviceId={sessionDeviceId}
      synthesizedFeedbackMetrics = {synthesizedFeedbackMetrics.current}
      DEFAULT_COLORS= {DEFAULT_COLORS}

      //left pane props
      selectedItemForRating={selectedItemForRating}
      setSelectedItemForRating={setSelectedItemForRating}
      evaluationOption={evaluationOption}
      likertOptions={likertOptions}
      ratings={ratings}
      setRatings={setRatings}
      notes={notes}
      setNotes={setNotes}
      handleRate={handleRate}
      completedCount={completedCount}
      submitted={submitted}
      handleSubmit={handleSubmit}
      evaluationOptionInstruction={evaluationOptionInstruction}
      currentIndex={currentIndex}
      handleNavigationChange={handleNavigationChange}
      handlePrev={handlePrev}
      handleNext={handleNext}
      speakers={speakers}

    />
  );
}

export { ExpertRatingComponent };
